import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import {
  Box,
  IconButton,
  Menu,
  Modal,
  Stack,
  TablePagination,
  Typography,
} from "@mui/material";
import {
  Close,
  DeleteOutline,
  EditOutlined,
  InfoOutlined,
} from "@mui/icons-material";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import { makeStyles, useTheme } from "@mui/styles";
import axios from "axios";
import DeleteAlert from "../AlertBox/DeleteAlert";
import SearchFeild from "./SearchFeild";
import EditJobRoleModal from "./EditJobRoleModal";
import {
  getJobRoleData,
  editJobRoleData,
  deleteJobRoles,
  editJobroleStatus,
} from "../../Redux/JobRole/action";
import { initailState } from "../../Pages/JobTabDashboard";
import { environmentDetails } from "../../../src/environment/environment";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { IOSSwitchButton } from "../ReusableComponents/SwitchButtons";
import ApiAlert from "../AlertBox/ApiAlert";
import { editCompanyStatus } from "../../Redux/HiringCompany/action";
import Tooltip from "@mui/material/Tooltip";
import { privateAxiosInstance } from "../../utils/axiosInstance";
import { accessTokenHeadersObject } from "../../utils/headers";
import IButtonModal from "../Modals/IButtonModal";
import img_not_found from "../../assets/img_not_found.jpg";
import { roleModulePermissions } from "../../utils/roleInstance";
import { deleteQuestionPackage } from "../../Redux/QuestionPacakge/action";
const apiUrl = environmentDetails.apiUrl;

const columns = [
  { id: "SNo", label: "Sl. #", minWidth: 30, align: "right" },
  { id: "JobRole", label: "Job Role", minWidth: 150, align: "left" },
  { id: "Skills", label: "Primary Skills", minWidth: 130, align: "left" },
  { id: "country", label: "Country", minWidth: 100, align: "left" },
  { id: "cities", label: "Cities", minWidth: 100, align: "left" },
  {
    id: "YearsOfExperience",
    label: "Years of Experience",
    minWidth: 130,
    align: "left",
  },
  {
    id: "JobDescription",
    label: "Job Description",
    minWidth: 100,
    align: "left",
  },
  {
    id: "ImageLink",
    label: "Job Description(Image)",
    miWidth: 110,
    align: "center",
  },
  { id: "Action", label: "Action", minWidth: 80, align: "center" },
];

const useStyles = makeStyles((theme) => ({
  editIconButton: {
    "&:hover": {
      color: "rgb(254, 154, 37)", // Set EditIcon hover text color here
    },
  },
  deleteIconButton: {
    "&:hover": {
      color: "red", // Set deleteIconButton hover text color here
    },
  },
  tableRow: {
    "& .MuiTableCell-root": {
      // borderRight: `1px solid ${theme.palette.grey[200]}`,
      borderRight: `1px solid gray`,
      borderBottom: "none",
      padding: 5,
      paddingTop: 8,
      paddingBottom: 8,
      cursor: "pointer",
      minWidth: 25,
      //this works but only for cell hover, not the full row
      "&:hover": {
        backgroundColor: "red",
      },
    },
  },
}));

const JobRoleTable = ({
  jobRoleData,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  getJobRoleDataFn,
}) => {
  const rows = jobRoleData?.data || [];
  const classes = useStyles();
  const dispatch = useDispatch();
  const [image, setImage] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [editData, setEditData] = useState({});
  //const [idToDelete, setIdToDelete] = useState(null);
  const [switchInactive, setSwitchInactive] = useState(null);
  const [copyStatus, setCopyStatus] = useState(Boolean);
  const [jobIdCopyStatus, setJobIdCopyStatus] = useState(0);
  let isLengthChange = jobRoleData?.length !== 0 ? true : false;
  const [idToDelete, setIdToDelete] = useState(null);
  const [alert, setAlert] = useState(false);
  const [alertContent, setalertcontent] = useState("");
  const [alertStatus, setAlertStatus] = useState(Boolean);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = useState(null);
  const [showDesc, setShowDesc] = useState("");
  const [showImage, setShowImage] = useState("");
  const [openingsWithJobId, setOpeningsWithJobId] = useState(0);
  const [showSkill, setShowSkill] = useState("");
  const [jobRole, setJobRole] = useState(null);
  const [openingsWithJobIdCount, setOpeningsWithJobIdCount] = useState(0)
  const [openingsWithJobDetailsCount, setOpeningsWithJobDetailsCount] = useState(0)
  const theme = useTheme();

  const openJobDesc = Boolean(anchorEl);
  const openJobImage = Boolean(anchorEl2);
  const openJobSkill = Boolean(anchorEl3);

  // useEffect(() => {
  //   console.log("jobRoleData inide j role table useeffect:--> ",jobRoleData)
  //   console.log("jobRoleData LENGTH inide j role table useeffect:--> ",jobRoleData?.dataLength)
  //   if (page !== 0) {
  //     setPage(0);
  //   }
  // }, [isLengthChange]);

  ////////////console.log(idToDelete);
  //console.log("TABLE ROWS:", rows);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    let val = +event.target.value;
    // if(val>=jobRoleData?.dataLength){
    //   setPage(0);
    // }
    setRowsPerPage(val);
    setPage(0);
  };

  const handleClickOpen = (data) => {
    setSwitchInactive(data);
    privateAxiosInstance
      .get(`/questionnaire/get-openingByJobRoleId/${data.jobId}`, {
        headers: { ...accessTokenHeadersObject() },
      })
      .then((res) => {
        setOpen(true);
        setOpeningsWithJobId(
          res.status === 200 ? res.data.openingsWithJobId : 0
        );
      })
      .catch((err) => {
        setOpen(true);
        setOpeningsWithJobId(0);
        //console.log("get opening by job ierrd==> ", err);
      });
  };

  const handleEditJobRole = (jobRole) => {
    // console.log("job roleeeee acha", jobRole);
    // editJobRole(jobRole);
    setEditData(jobRole);
    setOpenEdit(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleDeleteClose = () => {
    setOpenDelete(false);
  };

 const CampaignDelete = (id) => {
  return dispatch(deleteQuestionPackage(id))
    .then((res) => {
      setAlertStatus(res.payload?.status);
      setalertcontent(res.payload?.message);
      return res;
    })
    .catch((err) => {
      const msg = err?.payload?.message ?? err?.message ?? "Delete campaign failed";
      setAlertStatus(false);
      setalertcontent(msg);
      return Promise.reject(err);
    });
};

const jobRoleDelete = (id) => {
  return dispatch(deleteJobRoles(id))
    .then((res) => {
      setOpenEdit(false);
      setAlert(true);
      setAlertStatus(res.payload?.status);
      setalertcontent(res.payload?.message);
      handleDeleteClose();
      return res;
    })
    .catch((err) => {
      const msg = err?.payload?.message ?? err?.message ?? "Delete role failed";
      setAlert(true);
      setAlertStatus(false);
      setalertcontent(msg);
      return Promise.reject(err);
    });
};

const handleRoleOpeningDeletion = async () => {
  try {
    if (openingsWithJobIdCount > 0) {
      const ids = openingsWithJobDetailsCount.map(e => e.openingId);
      await Promise.all(ids.map(id => CampaignDelete(id)));
      await jobRoleDelete(jobRole.jobId);
    } else {
      await jobRoleDelete(jobRole.jobId);
    }
  } catch (err) {
    // any campaign delete failed — job role deletion will not run
    console.error("Deletion error:", err);
    handleDeleteClose();
  }
};



  const jobRoleEdit = (jobId, data) => {
    dispatch(editJobRoleData(jobId, data))
      .then((res) => {
        console.log("res from tab", res);
        setOpenEdit(false);
        // dispatch(getJobRoleData());
        setAlert(true);
        console.log("status", res.payload.status);
        setAlertStatus(res.payload.status);
        setalertcontent(res.payload.message);
        getJobRoleDataFn();
        setImage([]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeSwitch = (data) => {
    // console.log(data);
    var statusChange = true;
    const jobRoleStatus = data.jobRoleStatus;
    if (jobRoleStatus === true) {
      statusChange = false;
    } else if (jobRoleStatus === false) {
      statusChange = true;
    }
    // console.log("statusChange", statusChange);
    dispatch(editJobroleStatus(data.jobId, statusChange))
      .then((res) => {
        if (res.type === "EDIT_JOBROLE_STATUS_SUCCESS") {
          setAlert(true);
          setAlertStatus(res.payload.status);
          setalertcontent(res.payload.message);
        } else {
          setAlert(true);
          setAlertStatus(res.payload.status);
          setalertcontent(res.payload.message);
        }
        dispatch(getJobRoleData());
        handleClose();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (data) => {
    console.log("kjsfbjkdsnbkesnbkesnbkjn");
    
    if (data?.jobRole?.role === "Any Open Position") {
      setAlert(true);
      setAlertStatus(false);
      setalertcontent("You can't delete the 'Any Open Position' campaign.");
      return;
    }
    privateAxiosInstance
      .get(`/questionnaire/get-openingByJobRoleId/${data.jobId}`, {
        headers: { ...accessTokenHeadersObject() },
      })
      .then((res) => {
        console.log(res.data.openingsWithJobId);
        setOpeningsWithJobIdCount(res.data.openingsWithJobId);
        setOpeningsWithJobDetailsCount(res.data.openingDetails)
      })
      .catch((err) => {
        setAlert(true);
        setAlertStatus(false);
        setalertcontent("Some error occured");
      });
    setJobRole(data)
    setOpenDelete(true);
    setIdToDelete(data.openingId);
  };
  const handleCopyImage = (imageLink, jobId) => {
    if (navigator.clipboard.writeText(imageLink)) {
      setCopyStatus(true);
      setJobIdCopyStatus(jobId);
    } else {
      setCopyStatus(false);
    }
  };

  const AlerthandleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlert(false);
  };

  // Check Role Permission
  const [jobEditAction, setJobEditAction] = useState("");
  const [jobDeleteAction, setJobDeleteAction] = useState("");

  const checkJobEditAction = async () => {
    const roleData = {
      roleModule: "Job Role",
    };
    let rolePermission = await roleModulePermissions.checkUserRoles(
      roleData,
      "edit"
    );
    // return rolePermission
    setJobEditAction(rolePermission);
  };

  const checkJobDeleteAction = async () => {
    const roleData = {
      roleModule: "Job Role",
    };
    let rolePermission = await roleModulePermissions.checkUserRoles(
      roleData,
      "delete"
    );
    // return rolePermission
    setJobDeleteAction(rolePermission);
  };

  useEffect(() => {
    checkJobEditAction();
    checkJobDeleteAction();
  }, [page]);
  // Check Role Permission

  return (
    <>
      {/* ✅ This Box defines the total area for your table component */}
      <Box sx={{ width: "100%", height: "calc(100vh - 200px)" }}>
        <Paper
          sx={{
            width: "100%",
            height: "100%", // Fill the height of the parent Box
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* ✅ This container now grows to fill the space and handles scrolling */}
          <TableContainer sx={{ flexGrow: 1, overflow: "auto" }}>
            <Table sx={{ minWidth: 1400 }}>
              <TableHead sx={{ position: "sticky", top: 0, zIndex: 2 }}>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      sx={{
                        minWidth: column.minWidth,
                        backgroundColor: "primary.main",
                        color: "secondary.main",
                        fontWeight: 600,
                        ...(column.id === "Action" && {
                          position: "",
                          right: 0,
                          zIndex: 3,
                        }),
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow
                    key={row.jobId || index}
                    sx={{
                      cursor: row.jobRoleStatus ? "pointer" : "not-allowed",
                      opacity: row.jobRoleStatus ? 1 : 0.6, // makes disabled rows look dimmed
                      backgroundColor: (theme) =>
                        row.jobRoleStatus
                          ? theme.palette.background.paper // normal
                          : theme.palette.action.disabledBackground, // subtle grey for disabled
                      "&:hover": {
                        backgroundColor: (theme) =>
                          row.jobRoleStatus
                            ? theme.palette.action.hover
                            : theme.palette.action.disabledBackground, // prevent hover color on disabled
                      },
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <TableCell align="right">
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell align="left">{row?.role}</TableCell>
                    <TableCell align="left">
                      <Stack direction="row" alignItems="center" spacing={0}>
                        <Typography
                          variant="body2"
                          component="span"
                          noWrap
                          sx={{ maxWidth: 120 }}
                        >
                          {(Array.isArray(row?.skill)
                            ? row.skill.join(", ")
                            : row?.skill) || "N/A"}
                        </Typography>
                        {row?.skill?.length > 0 && (
                          <Tooltip title="View all skills" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                setAnchorEl3(e.currentTarget);
                                setShowSkill(
                                  Array.isArray(row.skill)
                                    ? row.skill.join(", ")
                                    : row.skill
                                );
                              }}
                            >
                              <InfoOutlined sx={{ fontSize: "1rem" }} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell align="left">{row?.country}</TableCell>
                    <TableCell align="left">
                      {(Array.isArray(row?.cities)
                        ? row.cities.join(", ")
                        : row?.cities) || "N/A"}
                    </TableCell>
                    <TableCell align="left">
                      {row?.yearsOfExperience || "N/A"}
                    </TableCell>
                    <TableCell align="left">
                      <Stack direction="row" alignItems="center" spacing={0}>
                        <Typography
                          variant="body2"
                          component="span"
                          noWrap
                          sx={{ maxWidth: 120 }}
                        >
                          {row?.desc?.replace(/<[^>]*>/g, "") || "N/A"}
                        </Typography>
                        {row?.desc && (
                          <Tooltip title="View full description" arrow>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                setAnchorEl(e.currentTarget);
                                setShowDesc(row.desc);
                              }}
                            >
                              <InfoOutlined sx={{ fontSize: "1rem" }} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      {row?.image ? (
                        <Tooltip title="Click to view image" arrow>
                          <Box
                            component="img"
                            src={row.image}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = img_not_found;
                            }}
                            onClick={(e) => {
                              setAnchorEl2(e.currentTarget);
                              setShowImage(row.image);
                            }}
                            sx={{
                              width: 60,
                              height: 70,
                              borderRadius: 2,
                              cursor: "pointer",
                              objectFit: "cover",
                              border: "1px solid black",
                            }}
                          />
                        </Tooltip>
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        position: "",
                        right: 0,
                        zIndex: 1,
                      }}
                    >
                      <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={1}
                      >
                        <Tooltip
                          title={
                            copyStatus && row.jobId === jobIdCopyStatus
                              ? "Copied!"
                              : "Copy Image Link"
                          }
                          arrow
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleCopyImage(row?.image, row?.jobId)
                            }
                            disabled={!row.image}
                          >
                            {copyStatus && row.jobId === jobIdCopyStatus ? (
                              <FileDownloadDoneIcon
                                fontSize="small"
                                color="success"
                              />
                            ) : (
                              <ContentCopyRoundedIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Tooltip>
                        {jobEditAction && (
                          <Tooltip title="Edit job role" arrow>
                            <IconButton
                              size="small"
                              onClick={() => handleEditJobRole(row)}
                              disabled={!row.jobRoleStatus}
                              sx={{ "&:hover": { color: "rgb(254, 154, 37)" } }}
                            >
                              <EditOutlined fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title="Delete" arrow>
                          <span>
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(row)}
                              disabled={!row.jobRoleStatus}
                              sx={{ "&:hover": { color: "error.main" } }}
                            >
                              <DeleteOutline fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                        {jobDeleteAction && (
                          <Tooltip
                            title={
                              row.jobRoleStatus ? "Deactivate" : "Activate"
                            }
                            arrow
                          >
                            <Box sx={{ transform: "scale(0.7)" }}>
                              <IOSSwitchButton
                                checked={row.jobRoleStatus}
                                onChange={() =>
                                  row.jobRoleStatus
                                    ? handleClickOpen(row)
                                    : handleChangeSwitch(row)
                                }
                              />
                            </Box>
                          </Tooltip>
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={jobRoleData?.dataLength || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ flexShrink: 0, borderTop: 1, borderColor: "divider" }}
          />
        </Paper>
      </Box>

      {/* --- Modals and Alerts --- */}
      <DeleteAlert
        open={open}
        onClose={handleClose}
        handleDelete={() => handleChangeSwitch(switchInactive)}
        rightButton={"Deactivate"}
        header={"Deactivate Job Role"}
        message={
          openingsWithJobId > 0
            ? `This job role is linked to ${openingsWithJobId} opening(s). Deactivating it will also affect them. Are you sure you want to proceed?`
            : "Are you sure you want to deactivate this job role?"
        }
      />
      <DeleteAlert
        open={openDelete}
        onClose={handleDeleteClose}
        handleDelete={handleRoleOpeningDeletion}
        rightButton="Delete"
        header="Confirm Deletion"
        message={openingsWithJobIdCount > 0 ? `This job role is linked to ${openingsWithJobIdCount} opening(s). Deleting it will also affect them. Are you sure you want to proceed?` : "Are you sure you want to delete this jobrole?"}
      />
      {openEdit && (
        <EditJobRoleModal
          open={openEdit}
          setOpen={setOpenEdit}
          data={editData}
          jobRoleEdit={jobRoleEdit}
          image={image}
          setImage={setImage}
        />
      )}
      <ApiAlert
        open={alert}
        snackbaronClose={AlerthandleClose}
        alertType={alertStatus ? "success" : "error"}
        Content={alertContent}
      />
      <IButtonModal
        type="text"
        element={showSkill}
        anchorEl={anchorEl3}
        setAnchorEl={setAnchorEl3}
      />
      <IButtonModal
        type="html"
        element={showDesc}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      />
      <IButtonModal
        type="img"
        element={showImage}
        anchorEl={anchorEl2}
        setAnchorEl={setAnchorEl2}
      />
    </>
  );
};

export default JobRoleTable;
